import { styled } from '@mui/material/styles';

import { MplButton } from '../../atoms/MplButton/MplButton';

export const NameChangeNoteRoot = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

// Figma: RPA/BUTTON/BU1-M
export const SupportButton = styled(MplButton)(({ theme }) => ({
	...theme.typography['bu1-m'],
	alignSelf: 'center',
	marginTop: '4px',
	color: theme.palette.primary.main,

	// The shared ExternalLinkIcon is a fixed 12x13; Figma draws it at 24px.
	// Scale it up here (aspect preserved) so it reads closer to the design
	// without touching the icon used elsewhere.
	'& .MuiButton-endIcon svg': {
		width: '20px',
		height: 'auto',
	},
}));
